import script from "./custTimbre.vue?vue&type=script&setup=true&lang=ts"
export * from "./custTimbre.vue?vue&type=script&setup=true&lang=ts"

import "./custTimbre.vue?vue&type=style&index=0&id=e54a9952&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e54a9952"]])

export default __exports__